module.exports = __webpack_public_path__ + "static/media/payment-card-header-bg.fbd5be01.svg";